import 'waypoints/lib/noframework.waypoints.min';

const historyTimelines = [...document.querySelectorAll('.js-historyTimeline')];

if (historyTimelines.length > 0) {
  historyTimelines.forEach(historyTimeline => {
    const plumbobWrapper = historyTimeline.querySelector('.js-plumbTimeLineWrapper');
    const momentSections = [...historyTimeline.querySelectorAll('.js-moment')];

    // Useful Measurements
    const pbInitTop = parseInt(
      window.getComputedStyle(plumbobWrapper).getPropertyValue('top'),
      0
    );

    momentSections.forEach(function configWaypoint(moment) {
      const waypoint = new Waypoint({
        element: moment,
        handler: () => {
          // const positionTop = moment.scrollTop - historyTimeline.offsetTop;
          const halfWay = moment.offsetTop + moment.clientHeight / 4;

          // eslint-disable-next-line no-param-reassign
          plumbobWrapper.style.top = `${halfWay}px`;
        },
        offset: '50%',
      });
    });
  });
}
